import { createFileRoute } from '@tanstack/react-router';

import { FaqPageContent } from '#features/faq/components/FaqPageContent';
import { staticPageHead } from '#features/static-pages/utils/head';

const title = 'Teamplay FAQ | Teamplay.gg';
const description =
  'Answers to common questions about Teamplay.gg – finding teammates, LFG posts, scheduled sessions, Discord voice channels, notifications, and installing the app.';

export const Route = createFileRoute('/{-$locale}/_layout/faq')({
  component: FaqPage,
  head: () => staticPageHead({ title, description, pathname: '/faq' }),
});

function FaqPage() {
  return <FaqPageContent />;
}
